module.exports = __webpack_public_path__ + "img/product_64.9f01c13.svg";